@if (isBetbuilderCombo) {
    <div>
        @for (bet of bets; track bet) {
            <span class="mybets-betslip-multi-bet clearfix">
                <div class="mybets-betslip-multi-bet_indicator">
                    <ms-my-bets-multi-bet-card-indicator
                        [bet]="bet"
                        [event]="bet.event"
                        [result]="getExpandedCardState(bet)"></ms-my-bets-multi-bet-card-indicator>
                </div>
                <div class="mybets-betslip-multi-bet_betbuilder" [ngClass]="isEpcotEnabled ? 'epcot-enabled-collapsed' : 'epcot-disabled-collapsed'">
                    @if (bet.betBuilderInfo) {
                        <div>
                            <div class="mybets-betslip-info_right-section clearfix">{{ bet.odds | msMyBetsOddsPipe }}</div>
                            @if (isEpcotEnabled) {
                                @if (myBetsConfig.showBetTypeAsBadge && myBetsUtilService.isBetCardRedesigned()) {
                                    <ms-sgp-badge size="large" />
                                } @else {
                                    <span class="mybets-betslip-multi-bet_betbuilder-title-epcot">{{ sitecoreMyBets.myBets.BuildABet }}</span>
                                }
                                <span class="mybets-betslip-multi-header_pick-count combo-bet">
                                    {{ bet.betBuilderInfo!.legs.length }} {{ sitecoreMyBets.myBets.Legs }}</span
                                >
                            } @else {
                                <span class="mybets-betslip-multi-bet_betbuilder-title">{{ sitecoreMyBets.myBets.BuildABet }}</span>
                                <span class="mybets-betslip-multi-header_pick-count">
                                    - {{ bet.betBuilderInfo!.legs.length }} {{ sitecoreMyBets.myBets.picks }}</span
                                >
                            }
                        </div>
                    }
                    @if (!bet.betBuilderInfo) {
                        <div class="mybets-betslip-info_pick-name">
                            {{ bet.optionName }}
                        </div>
                    }
                    <div class="mybets-betslip-non-event-info_event-name highlight">
                        {{ bet.eventName }}
                    </div>
                </div>
            </span>
        }
    </div>
} @else {
    <div class="mybets-betslip-multi-collapsed-view_options clearfix">
        @for (bet of bets; track bet) {
            <span class="mybets-betslip-multi-collapsed-view_option-name">{{ bet.optionName }}</span>
        }
    </div>
    <div class="mybets-betslip-multi-collapsed-view_indicators">
        @if (isLive) {
            <span class="mybets-scoreboard_info-live-badge">{{ sitecoreMyBets.myBets.Live }}</span>
        }
        @for (bet of bets; track bet) {
            <ms-my-bets-multi-bet-card-indicator [bet]="bet" [event]="bet.event" [result]="getExpandedCardState(bet)" />
        }
    </div>
}
